import React, { useEffect, useState } from "react";
import { Menu, X, Anchor } from "lucide-react";
import HypeHafenLogo from "./HypeHafenLogo";

const NAV = [
  { id: "leistungen", label: "Leistungen" },
  { id: "ueber-uns", label: "Über uns" },
  { id: "prozess", label: "Prozess" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#2E2E2E]/95 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-4">
        <button
          onClick={() => handleNav("hero")}
          data-testid="nav-logo"
          className="flex items-center shrink-0"
        >
          <HypeHafenLogo height={44} />
        </button>

        <nav className="hidden lg:flex items-center gap-10" data-testid="nav-links">
          {NAV.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNav(item.id)}
              data-testid={`nav-link-${item.id}`}
              className="font-body text-[0.95rem] text-white/85 hover:text-[#FFF44F] transition-colors duration-200"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => handleNav("kontakt")}
            data-testid="nav-contact-button"
            className="hh-btn-primary !py-2 !px-4 text-sm md:!py-3 md:!px-5 md:text-base"
          >
            <Anchor className="w-4 h-4" />
            Kontakt
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden w-11 h-11 rounded-full border border-white/15 text-white flex items-center justify-center"
            aria-label="Menü öffnen"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile sheet */}
      {open && (
        <div className="lg:hidden bg-[#2E2E2E] border-t border-white/5" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNav(item.id)}
                data-testid={`mobile-nav-link-${item.id}`}
                className="text-left font-display text-white text-xl py-2 border-b border-white/5"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("kontakt")}
              data-testid="mobile-nav-contact-button"
              className="hh-btn-primary w-full justify-center mt-2"
            >
              Kostenloses Erstgespräch
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
